import React, { useState } from 'react';
import { Form as FinalForm } from 'react-final-form';
import { required } from '../../util/validators';
import { reportUser } from '../../util/api.js';

import {
    PrimaryButton,
    Form,
    FieldTextInput,
    Modal,
} from '../../components';
import css from './ReportUserModal.module.css';

const ReportUserModal = (props) => {
    const [loading, setLoading] = useState(false);
    const [status, setStatus] = useState("init");

    const {
        isOpen,
        onClose,
        onManageDisableScrolling,
        currentUser,
        userToReport,
    } = props;

    const onSubmit = values => {
        setLoading(true);
        setStatus("init");
        reportUser({
            reporterName: currentUser?.attributes?.profile?.displayName,
            reporterId: currentUser?.id?.uuid,
            reportedName: userToReport?.attributes?.profile?.displayName,
            reportedId: userToReport?.id?.uuid,
            ...values,
        })
            .then(() => {
                setStatus("submitted");
            })
            .catch(() => {
                setStatus("failed");
            })
            .finally(() => {
                setLoading(false);
            });
    };

    return <div>
        <Modal
            id="ReportUserModal"
            isOpen={isOpen}
            onClose={onClose}
            onManageDisableScrolling={onManageDisableScrolling}
            usePortal
        >
            <FinalForm
                onSubmit={onSubmit}
                render={fieldRenderProps => {
                    const {
                        handleSubmit,
                        invalid,
                    } = fieldRenderProps;

                    const submitDisabled = invalid || loading;

                    return <Form className={css.form} onSubmit={handleSubmit}>
                        <h3 className={css.title}>Report User</h3>

                        <FieldTextInput
                            className={css.field}
                            type="textarea"
                            id="extraInfo"
                            name="extraInfo"
                            label="Tell us more"
                            validate={required("Required")}
                        />

                        {status == "submitted" ? <PrimaryButton
                            className={css.submitButton}
                            type="button"
                            onClick={onClose}
                        >
                            Close
                        </PrimaryButton> : <PrimaryButton
                            className={css.submitButton}
                            type="submit"
                            inProgress={loading}
                            disabled={submitDisabled}
                        >
                            Submit
                        </PrimaryButton>}

                        {status == "failed" ? <p>
                            Failed to report user, please refresh the page and try again!
                        </p> : status == "submitted" ? <p>
                            Thank you, We've received your report.
                        </p> : null}
                    </Form>
                }}
            />
        </Modal>
    </div>
};

export default ReportUserModal;
